import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import { getMessageBoardSearch } from "../api/getMessageBoard";

class MessageBoardSearchContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, addRe: true, type: "comment-search", filter: this.props.filter, items: [] };
  }
  fetch = () => {
    this.props.request(this.state.filter, this.state.page).then(({ data }) => {
      const hasMore = data && data.next_page !== 0;
      const items = this.state.items.slice(0);
      data && data.posts.map(t => items.push(t));
      this.setState({ items, page: (this.state.page += 1), hasMore });
    });
  };
}

MessageBoardSearchContainer.defaultProps = {};
export default CreateContainer(getMessageBoardSearch, MessageBoardSearchContainer);
